var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "record-wrap"
    },
    [
      _c(
        "div",
        { staticClass: "company-list" },
        _vm._l(_vm.corpList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              class:
                _vm.detailInfo.activeCorp == item.corpId
                  ? "tag-company active-tag-company"
                  : "tag-company",
              on: {
                click: function($event) {
                  return _vm.handleCompany(item)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item.corpName) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "recprd-list-wrap" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.detailInfo.activeName,
                callback: function($$v) {
                  _vm.$set(_vm.detailInfo, "activeName", $$v)
                },
                expression: "detailInfo.activeName"
              }
            },
            [
              _vm.lianLianAccountStatus.open
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "连连", name: "LianLian" } },
                    [
                      _c("LianTransDetail", {
                        ref: "LianLianDetail",
                        attrs: {
                          detailInfo: _vm.detailInfo,
                          supplierId: _vm.supplierId,
                          trxOptions: _vm.LianLianTrxOptions
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "锐锢", name: "RuiGu" } },
                [
                  _c("RuiGuTransDetail", {
                    ref: "RuiGuDetail",
                    attrs: { detailInfo: _vm.detailInfo }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b925275", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b925275","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purseSetting/record/record.vue
// module id = null
// module chunks = 